import { createContext, useState, useContext, useEffect } from 'react';

const KnowledgeBaseContext = createContext({
  knowledgeBaseUrl: '',
  activateKnowledgeBaseUrl: () => {
    throw Error('Should be inside KnowledgeBaseProvider');
  },
  deactivateKnowledgeBaseUrl: () => {
    throw Error('Should be inside KnowledgeBaseProvider');
  },
});

export const KnowledgeBaseProvider = ({ children, defaultUrl }) => {
  const [knowledgeBaseUrl, setKnowledgeBaseUrl] = useState(defaultUrl);

  const activateKnowledgeBaseUrl = (url) => setKnowledgeBaseUrl(url);
  const deactivateKnowledgeBaseUrl = () => setKnowledgeBaseUrl(defaultUrl);
  return (
    <KnowledgeBaseContext.Provider
      value={{
        knowledgeBaseUrl,
        activateKnowledgeBaseUrl,
        deactivateKnowledgeBaseUrl,
      }}
    >
      {children}
    </KnowledgeBaseContext.Provider>
  );
};

export const ActiveKnowledgeBase = ({ children, url }) => {
  const { activateKnowledgeBaseUrl, deactivateKnowledgeBaseUrl } =
    useKnowledgeBase();

  useEffect(() => {
    if (url) {
      activateKnowledgeBaseUrl(url);
    }

    return () => {
      deactivateKnowledgeBaseUrl();
    };
  }, [url]);

  return children;
};

export const useKnowledgeBase = () => useContext(KnowledgeBaseContext);

export default KnowledgeBaseContext;
